import { IntlShape } from 'react-intl';

export const getPaymentDetailsLabels = (itemName: string, intl: IntlShape) => ({
  itemName,
  subtotal: intl.formatMessage({ id: 'subtotal' }),
  tax: intl.formatMessage({ id: 'tax' }),
  total: intl.formatMessage({ id: 'total' }),
  credits: intl.formatMessage({ id: 'credits_applied' }),
});
